<template>
  <form
    class="api-keys-update-form"
    @submit.prevent="submitForm"
  >
    <div class="row bottom-xs">
      <div class="col-xs-12 col-md-5">
        <BaseInput
          label="Udstedes til"
          v-model="api.company"
          :disabled="loading"
        />
      </div>
      <div class="col-xs-12 col-md-2">
        <BaseFormField label="Aktiv">
          <BaseSelect
            label="name"
            :placeholder="api.status | IsActive"
            @select="updateStatus"
            :options="[{value: true, name: 'Aktiv'}, {value: false, name: 'Inaktiv'}]"
            :disabled="loading"
          />
        </BaseFormField>
      </div>
      <div class="col-xs-12 col-md-2">
        <BaseFormField label="Udvidet adgang">
          <BaseSelect
            label="name"
            :placeholder="api.extended | isExtended"
            @select="updateExtended"
            :options="[{value: true, name: 'Ja'}, {value: false, name: 'Nej'}]"
            :disabled="loading"
          />
        </BaseFormField>
      </div>
      <div class="col-xs-12 col-md-3 end-xs">
        <BaseButton
          label="Gem ændringer"
          full
          :disabled="loading"
        />
      </div>
    </div>
    <div
      class="api-keys-update-form__loading"
      v-if="loading"
    >
      <BaseSpinner
        height="40px"
        width="40px"
      />
    </div>
  </form>
</template>

<script>
import BaseSpinner from '../../BaseSpinner.vue';
import BaseSelect from '../../BaseSelect.vue';
import BaseFormField from '../../BaseFormField.vue';
import BaseButton from '../../BaseButton.vue';
import BaseInput from '../../BaseInput.vue';
import IsActive from '../../../filters/IsActive';
import IsExtended from '../../../filters/IsExtended';
import APIKeysService from '../../../services/APIKeysService';

export default {
    name: 'UpdateAPIKeysForm',
    components: {
        BaseInput, BaseButton, BaseFormField, BaseSelect, BaseSpinner,
    },
    props: {
        api: { type: Object, required: true },
    },
    filters: { IsActive, IsExtended },
    data() {
        return {
            loading: false,
        };
    },
    methods: {
        async submitForm() {
            try {
                this.loading = true;
                const payload = await APIKeysService.update(this.api);

                this.$snotify.success(`${payload.company} er opdateret`);
                this.loading = false;
            } catch (error) {
                this.loading = false;
            }
        },
        updateExtended(e) {
            this.$set(this.api, 'extended', e.value);
        },
        updateStatus(e) {
            this.$set(this.api, 'status', e.value);
        },
    },
};
</script>

<style lang="scss" scoped>
.api-keys-update-form {
    margin-top: 20px;
    background-color: $white2;
    padding: 10px;
    border-radius: 5px;
    position: relative;

    &__loading {
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
    }
}
</style>
